import HttpStatusCodes from './HttpStatusCodes';

export const ErrorHandler = (statusCode: number): void => {
  switch (statusCode) {
    case HttpStatusCodes.UNAUTHORIZED:
      window.location.replace('/login');
      break;

    case HttpStatusCodes.FORBIDDEN:
      window.location.replace('/403');
      break;

    case HttpStatusCodes.NOT_FOUND:
      window.location.replace('/404');
      break;

    case HttpStatusCodes.INTERNAL_SERVER_ERROR:
      window.location.replace('/500');
      break;
  }
};
